import { Table } from "react-bootstrap";
// import CustomButton from "../../../components/CustomButton";
// import { RiExchangeLine } from "react-icons/ri";
import { convertCurrency, numberFormat } from "../../../helper";
// import { useMemo } from "react";
import EmptyComponent from "../../../components/EmptyComponent";
import AnimationLoading from "../../../components/Animationloading";
// import { Add } from "@mui/icons-material";
import useWindowDimensions from "../../../helper/windowDimensions";
import { useTranslation } from "react-i18next";
import { ReactIcons } from "../../../icons";

function ProductTableList({
  _skip,
  _limit,
  products,
  selectedPrice,
  onSelectProduct,
  checkedProductSelected,
  onSelectOptionPrice,
  optionPrice,
  productLoading,
  productDatas
}) {
  const { height, width } = useWindowDimensions()

  const { t } = useTranslation();

   

  const filteredProducts = products;

  return (
    <div className="sale-list-left">
      {(!productDatas?.products && productLoading) ? (
        <AnimationLoading />
      ) : (
        <div className="sale-product-list">
          {filteredProducts?.length > 0 ? (
            <>
              <Table responsive style={{ backgroundColor: "#FFFF" }}>
                <thead>
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ borderTop: "none" }}>#</th>
                    {width > 700 && <th style={{ borderTop: "none" }}>{t("category_name_tb")}</th>}
                    <th style={{ borderTop: "none" }}>{t("product_name_tb")}</th>
                    <th style={{ borderTop: "none" }}>{t("variant_name_tb", { defaultValue: "ສິນຄ້າທີ່ມີຫຼາຍຄ່າ" })}</th>
                    <th style={{ borderTop: "none" }}>{t("tb_size", { defaultValue: "ຂະຫນາດ" })}</th>
                    <th style={{ borderTop: "none" }}>{t("qty_name_tb")}</th>
                    <th style={{ borderTop: "none" }}>{t("unit_name_tb")}</th>
                    <th style={{ borderTop: "none" }}>{t("price_name_tb")}</th>
                    {width < 700 && <th style={{ borderTop: "none" }}>Add</th>}
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts?.map((product, index) => (
                    <tr
                      key={index}
                      onClick={() => onSelectProduct(product)}
                      style={{
                        cursor: "pointer",
                        backgroundColor: checkedProductSelected(product)
                          ? "#ddd"
                          : "#fff",
                        color: checkedProductSelected(product)
                          ? "green"
                          : product?.amount <= 0 && product?.hasVariant === false
                            ? "red"
                            : product?.hasVariant === true ? "#000" :"",
                            fontWeight: product?.hasVariant === true ? "bold" : "",
                      }}>
                      <td>{index + 1 + _limit * (_skip - 1)}</td>
                      {width > 700 &&  <td>
                        {product?.category?.name ??
                          product?.categoryName ??
                          "-"}
                      </td>}
                      <td>
                        {product?.name ?? "-"}
                      </td>
                      <td>
                        {product?.hasVariant ? (
                          <ReactIcons.FaCheck 
                          // style={{ color: "green" }}
                          />
                        ) : (
                          <ReactIcons.MdCancel 
                          // style={{ color: "red" }}
                          />
                        )}
                      </td>
                      <td>
                        {product?.size ?? '-'}
                        {product?.dimension?.length ? '('+product?.dimension?.length+'x'+product?.dimension?.width+'x'+product?.dimension?.height+'x'+product?.dimension?.weight+')' : ''}
                      </td>

                      <td
                        style={{
                          color: product?.amount <= 0 && product?.hasVariant === false ? "red" : "",
                          fontWeight: product?.amount <= 0 && product?.hasVariant === false ? "bold" : "",
                        }}
                      >
                        {product?.hasVariant ? "-": numberFormat(product?.amount)}
                      </td>
                      <td>
                        {product?.unitId?.name ?? product?.unit ?? '-'}
                      </td>
                      <td>
                        <span style={{ marginRight: "5px", color: product?.amount <= 0 ? "red" : "green", }}>{convertCurrency(product?.currency)}</span>

                        {product?.isPromo ? (
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            {numberFormat(product?.promoPrice || 0)}
                          </span>
                        ) : (
                          numberFormat(
                            product?.priceOptions[parseInt(selectedPrice)]
                              ?.price ?? 0
                          )
                        )}
                        {" / " + 
                          numberFormat(
                            product?.priceOptions[parseInt(selectedPrice)]
                              ?.contain ?? 1
                          )}
                      </td>
                      {width < 700 &&<td>
                        <ReactIcons.MdAdd />
                      </td>
}

                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <div
              style={{
                fontSize: "18px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "75vh",
                color: "#6B7280",
                fontWeight: "400",
              }}>
              <EmptyComponent />
              <p>{t("empty_name_list")}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ProductTableList;
